<template>
    <div>
        <label for="titles" class="sr-only">All Titles</label>
        <select class="form-control" v-model="selectedTitle" id="titles">
            <option value="" selected="selected">All Titles</option>
            <option v-for="title in titles"
                    v-bind:value="title">
                {{title.title}}
            </option>
        </select>
    </div>
</template>

<script>
  export default {
    props: ['initial'],
    data: function () {
      return {
        selectedTitle: "",
        titles: window.titleList,
      };
    },
    watch: {
      selectedTitle: function (newTitle, oldTitle) {
        if(this.initial !== newTitle) {
          console.log('emitting title change');
          this.$emit('change:titlefilter', newTitle);
        } else {
          console.log('not emitting title change, same title as start');
        }
      },
      initial: function(newInitial, oldInitial) {
        console.log('new initial value');
        if(this.initial != this.selectedTitle) {
          this.selectedTitle = this.initial;
        }
      }
    },
    mounted: function() {
      if(this.initial) {
        this.selectedTitle = this.initial;
      }
    }
  }
</script>
